export default __webpack_public_path__ + "static/media/github-select-release.3269373b.png";